<header role="menubar">
  <button type="button"
          menu
          [attr.aria-label]="'HEADER.OPEN_MENU' | translate"
          onclick="headerMenu.showModal()">
    <app-svg class="action-icon"
             use="menu"></app-svg>
  </button>
  <nav product-menu>
    <app-nav-list [items]="menu?.productMenu??[]"
                  role="group"></app-nav-list>
  </nav>
  @if(logoUrl(); as logo) {
  <a logo
     [attr.aria-label]="'HEADER.LOGO_LABEL' | translate"
     [href]="logo.link"
     target="_self">
    <img class="logo"
         role="presentation"
         fit="height"
         loading="eager"
         [use]="logo.url"
         [sizes]="logo.sizes"
         [srcset]="logo.srcset" />
  </a>
  }
  <nav content-menu>
    <app-nav-list [items]="menu?.contentMenu??[]"
                  role="group"></app-nav-list>
  </nav>
  <button type="button"
          search
          [attr.aria-label]="'HEADER.OPEN_SEARCH' | translate"
          onclick="headerSearch.showModal()">
    <app-svg class="action-icon"
             use="search"></app-svg>
  </button>
  <!-- <button type="button"
          authentication
          [attr.aria-label]="'HEADER.OPEN_LOGIN' | translate"
          popovertarget="headerLogin"
          popovertargetaction="toggle">
    <app-svg class="action-icon"
             [use]="login()?.icon??'lock-up'"></app-svg>
  </button> -->
  <button type="button"
          basket
          [attr.aria-label]="'HEADER.OPEN_BASKET' | translate"
          onclick="headerBasket.showModal()">
    <app-svg class="action-icon"
             [attr.quantity]="basket()?.quantity??0"
             use="basket"></app-svg>
  </button>
</header>
<a class="cta"
   [attr.href]="menu?.ctaLink??null"
   [style.color]="menu?.ctaColor"
   [style.background-color]="menu?.ctaBackgroundColor"
   [style.background-image]="menu?.ctaBackgroundImage"
   [style.font-family]="menu?.ctaFontFamily"
   [innerHTML]="menu?.ctaText"
   cta></a>
<dialog popover
        [modal]="true"
        id="headerMenu"
        slide="menu">
  <!-- onbeforetoggle="setTimeout(() => {this.querySelectorAll('[open]').forEach(e => e.removeAttribute('open'))},200)" -->
  <button type="button"
          closeDialog> </button>
  <nav role="menu">
    @if((menu?.productMenu?.length??0) > 0) {
    <app-nav-fragment [items]="menu?.productMenu??[]"
                      role="group"
                      id="productMenu"></app-nav-fragment>
    }
    @if((menu?.contentMenu?.length??0) > 0) {
    <app-nav-fragment [items]="menu?.contentMenu??[]"
                      role="group"
                      id="contentMenu"></app-nav-fragment>
    }
  </nav>
</dialog>
<!-- <div popover
     id="headerLogin"
     popup="bottom">
  <button type="button"
          popovertarget="headerLogin"
          popovertargetaction="hide"
          icon="close"
          [attr.aria-label]="'BUTTON.CLOSE'|translate"> </button>
  <app-authentication-login-form></app-authentication-login-form>
</div> -->
<dialog id="headerSearch"
        [modal]="true"
        slide="right"
        (closedEvent)="searchBar.reset()">
  <button type="button"
          closeDialog> </button>
  <app-product-search-bar #searchBar
                          [initialValue]="productSearchRequest()?.searchTerms"
                          (request)="productSearchRequest.set($event)"
                          (submit)="searchSubmit($event)"></app-product-search-bar>
  @if(productSearchResult()|async; as result) {
  <app-product-search-list view="list"
                           [leaveEmpty]="(search()?.query?.length??0) == 0"
                           araia-live="polite"
                           [result]="result"></app-product-search-list>
  @if((result.results?.length??0)>0) {
  <a [href]="searchLink()"
     button="solid">{{ 'SEARCHTERMS.SHOW_MORE_RESULTS' | translate }}</a>
  }
  }

</dialog>
<dialog id="headerBasket"
        [modal]="true"
        slide="right">
  <button type="button"
          closeDialog> </button>
  <h4>{{ 'HEADER.MINI_BASKET_TITLE' | translate:{quantity:basket()?.quantity} }}</h4>
  <app-ecommerce-basket-static></app-ecommerce-basket-static>
  <app-ecommerce-summary></app-ecommerce-summary>
  <a [href]="basketUrl"
     class="basket-button"
     icon="chevron-right"
     button="solid">{{ 'HEADER.MINI_BASKET_BUTTON' | translate }}</a>
</dialog>

@for(current of notificationList(); let last=$last; track $index) {
@if(last) {
<div id="notification"
     [attr.icon]="current?.icon"
     [attr.position]="current?.position"
     [style.--color]="current?.color"
     [style.--backgroundColor]="current?.backgroundColor"
     [style.animation-delay.ms]="current?.duration"
     [ngStyle]="current?.style"
     aria-live="assertive">
  <span>{{ current?.title }}</span>
  <span>{{ current?.text }}</span>
</div>
}
}
<main>
  <router-outlet></router-outlet>
</main>
<footer>
  <div>
    <section [attr.aria-label]="'FOOTER.SECTION_MENU'|translate">
      <nav>
        <app-nav-fragment [items]="menu?.footerMenu??[]"
                          role="group"
                          id="footerMenu"></app-nav-fragment>
      </nav>
    </section>
    <section [attr.aria-label]="'FOOTER.SECTION_CONTENT'|translate">
      <app-grid [content]="menu?.footerContent ?? []"></app-grid>
    </section>
    <section [attr.aria-label]="'FOOTER.SECTION_OPEN_HOURS'|translate">
      <app-store-hours-of-operation>
        <h3 title>{{ 'ECOMMERCE.STORE_HOURS_OF_OPERATION' | translate }}</h3>
      </app-store-hours-of-operation>
    </section>
    <section [attr.aria-label]="'FOOTER.SECTION_CONTACT'|translate">
      <app-store-contact>
        <h3 title>{{ 'ECOMMERCE.STORE_CONTACT' | translate }}</h3>
      </app-store-contact>
    </section>
  </div>
</footer>
<div class="bedrock">
  <div class="wrapper">
    <section [attr.aria-label]="'FOOTER.SECTION_SOCIAL'|translate"
            style="align-items: end; display: grid;">
      <app-social-links>
        <i title>{{ 'SOCIAL.TITLE' | translate }}</i>
      </app-social-links>
    </section>
    <section [attr.aria-label]="'FOOTER.SECTION_PAYMENT_CARDS'|translate"
            style="align-items: end; display: grid;">
      <app-ecommerce-payment-cards>
        <i title>{{ 'PAYMENT_CARDS.TITLE' | translate }}</i>
      </app-ecommerce-payment-cards>
    </section>
    <section aria-label="'FOOTER.SECTION_MARKET_SELECTOR'">
      <app-ecommerce-market-selector>
        <i title>{{ 'MARKET_SELECTOR.TITLE' | translate }}</i>
      </app-ecommerce-market-selector>
    </section>
  </div>
</div>
<app-fab-outlet></app-fab-outlet>
